import { render, staticRenderFns } from "./SelectPropertiesDropdown.vue?vue&type=template&id=2877ffc8"
import script from "./SelectPropertiesDropdown.vue?vue&type=script&lang=js"
export * from "./SelectPropertiesDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectPropertiesDropdown.vue?vue&type=style&index=0&id=2877ffc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports